import React from 'react'

export default function Spacer() {
    return (
        <div className='h-12 lg:h-32 bg-primary'>
            {/* images will be here */}
        </div>
    )
}
